export default __webpack_public_path__ + "static/media/profile-data-rafiki.d2144a7f.png";